import axios from 'axios';
import {
	ApproveSmsCode,
	GenerateCodeData,
	RegisterClientData,
	UserInfoEditType,
	ApproveBonusSmsCode,
	MoveDataType,
} from '../types/TypesUser';
import store from '../redux/store';
import {
	GetDeliveryAddressData,
	GetDeliveryContactsData,
} from '../types/DeliveryData';
import {
	DeferredSaveType,
	OrderConfirmDataType,
	RequestOrdersDataType,
	RequestPaymentCreateType,
	RequestPaymentListType,
	UpdateOrderDataType,
} from '../types/TypesUserOrders';
import {RequestDataTypes} from '../types/TypesNews';
import {
	ConversionCreateType,
	CreateDataTransfer,
	CreateDataWithdrawal,
	RequestBillingTransactions,
	RequestPremiaType,
} from '../types/TypesUserAccounts';
import {RequestTeamType} from '../types/TypesPage';
import {
	ApproveOrderRequestType,
	CreateInvoiceType,
	RequestApproveProductsType,
	RequestOrdersListType,
} from '../types/TypesStore';
import i18n from 'i18next';
import {ProductsListRequestType} from '../types/ProductSliceTypes';
import {
	RequestPaperworkHistoryType,
	RequestPaperworkListType,
} from '../types/TypesDepotPaperwork';
import {CreateActivitiesRequestType} from '../types/ActivitiesSliceTypes';
import {
	DeleteLogisticOrder,
	LogisticListRequestType,
} from '../types/TypesDepotLogistic';
import {
	LoadFinStatProps,
	RequestBalanceProdType,
	RequestMovementType,
	RequestStatProdType,
} from '../types/StoreReportTypes';
import {AuthFormValues} from '../Components/AuthCashierPopup/AuthCashierPopup';
import {
	CashActionType,
	CashierActionType,
	CashierShiftExitType,
	RequestBillingListType,
	RequestCreateCashierOrderType,
	RequestCreateReceiptReturnType,
	RequestCreateReceiptType,
	RequestEditCashierOrderType,
	RequestPrintReceiptType,
} from '../types/CashierSliceStateType';
import {monthNow} from '../assets/utils/dateUtils';

export const instance = axios.create({
	withCredentials: true,
	baseURL: process.env.REACT_APP_BASE_URL,
	/*"https://api.choice.ua/api/",*/
	/* baseURL: "https://46.101.108.64/api/",*/
});

instance.interceptors.request.use((config) => {
	const state = store.getState();
	const lang = i18n.language;
	const token = state.appData?.session?.token;
	config.headers.Authorization = `Bearer ${token}`;
	if (config.method === 'post') {
		config.data.cstcode = state.appData?.session?.cstcode || '';
		config.data.user_id = state.appData?.session?.user_id?.toString();
		config.data.lang = lang;
		config.data.currency = state.appData?.session?.currency;
		config.data.initial_id = state.appData?.session?.user_id?.toString(); //80159 '38577''122433'
	}
	return config;
});

export const userAPI = {
	laraLogin() {
		return axios.get(`/api/api_token`);
	},
	login() {
		return instance.post(
			`login`,
			/*{
				email: 'dev@choice.ua',
				password: 'FxnLoC2Jib2h86ad',
			} */ {
				email: 'frontend@choice.ua',
				password: 'Ghd3*f)@Y1io',
			},
		);
	},
	getCartInfo() {
		return axios.get(`${process.env.REACT_APP_BASE_LARA_URL}?route=cart`);
	},
	laraLogout() {
		return axios.get(`${process.env.REACT_APP_BASE_LARA_URL}?route=/logout`, {
			withCredentials: true,
		});
	},
	exit() {
		return instance.post(`clients/exit`, {});
	},
	getUserStat(month: string) {
		return instance.post(`user-stat/tree`, {month});
	},

	/*getActivityTree(month: string) {
		return instance.post(`user-stat/activity-tree`, {month});
	},*/
	getUserRef() {
		return instance.post(`user/ref-link`, {});
	},
	getStudyStatus() {
		return instance.post(`user/study-status`, {});
	},
	getUserInfo() {
		return instance.post(`user/info`, {});
	},
	getEditUserInfo(data: UserInfoEditType) {
		return instance.post(`user/info-edit`, data);
	},
	addUserPhoto(photo: File) {
		const formData = new FormData();
		formData.append('photo', photo);
		// Добавляем данные, которые ожидает интерцептор
		const state = store.getState();
		const lang = i18n.language;
		formData.append('cstcode', state.appData?.session?.cstcode || '');
		formData.append(
			'user_id',
			state.appData?.session?.user_id?.toString() || '',
		);
		formData.append('lang', lang);
		formData.append('currency', state.appData?.session?.currency || '');

		return instance.post(`user/download-photo`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	},
};
export const orderAPI = {
	getDeferredInfo() {
		return instance.post(`user-order/deferred-info`, {});
	},
	getDeferredSave(data: DeferredSaveType) {
		return instance.post(`user-order/deferred-save`, data);
	},
	getOrderConfirm(data: OrderConfirmDataType) {
		return instance.post(`user-order/confirm`, data);
	},
	getOrderService(country: string) {
		return instance.post(`user-order/service`, {country});
	},
	updateOrder(data: UpdateOrderDataType) {
		return instance.post(`user-order/edit`, data);
	},
	getOrderInfo(order_id: number) {
		return instance.post(`user-order/info`, {order_id});
	},
	getUserOrders(data: RequestOrdersDataType) {
		return instance.post(`user-order/list`, data);
	},
	getDeleteUserOrder(order_id: number) {
		return instance.post(`user-order/delete`, {order_id});
	},
	getUserOrderStoreList(data: RequestOrdersDataType) {
		return instance.post(`user-order/list-store`, data);
	},
	getUserOrderActivityList(data: RequestOrdersDataType) {
		return instance.post(`user-order/list-activity`, data);
	},
};
export const deliveryAPI = {
	getAddressesList(service_type: string) {
		return instance.post(`delivery/addresses-list`, {service_type});
	},
	getContactsList(supplier_id?: string) {
		return instance.post(`delivery/contacts-list`, {supplier_id});
	},
	createNewAddress(data: GetDeliveryAddressData) {
		return instance.post(`delivery/addresses-create`, data);
	},
	createNewContacts(data: GetDeliveryContactsData) {
		return instance.post(`delivery/contacts-create`, data);
	},
	getCityInNP(token: string, value: string) {
		return axios.post(`https://api.novaposhta.ua/v2.0/json/searchSettlements`, {
			apiKey: token,
			modelName: 'Address',
			calledMethod: 'searchSettlements',
			methodProperties: {
				CityName: value,
				Limit: '5',
				Page: '1',
			},
		});
	},
	getAreaInNP() {
		return axios.post(`https://api.novaposhta.ua/v2.0/json/searchSettlements`, {
			modelName: 'Address',
			calledMethod: 'getAreas',
			methodProperties: {},
		});
	},
	getAddressInNP(
		token: string,
		value: string,
		npCityRef: string,
		type: string,
	) {
		return axios.post(`https://api.novaposhta.ua/v2.0/json/searchSettlements`, {
			apiKey: token,
			modelName: 'Address',
			calledMethod: type, //"getStreet",
			methodProperties: {
				FindByString: value,
				CityRef: npCityRef,
				Page: '1',
			},
		});
	},
	getWarehousesInNP(
		token: string,
		cityRef: string,
		warehouseType?: 'branch' | 'postomat',
	) {
		const methodProperties: any = {
			CityRef: cityRef,
		};

		// Add TypeOfWarehouseRef based on warehouse type
		// Nova Poshta warehouse type GUIDs:
		// f9316480-5f2d-425d-bc2c-ac7cd29decf0 - Postomat (Parcel Locker)
		// 9a68df70-0267-42a8-bb5c-37f427e36ee4 - Branch (Відділення)
		if (warehouseType === 'postomat') {
			methodProperties.TypeOfWarehouseRef =
				'f9316480-5f2d-425d-bc2c-ac7cd29decf0'; // Postomat GUID
		} else if (warehouseType === 'branch') {
			methodProperties.TypeOfWarehouseRef =
				'9a68df70-0267-42a8-bb5c-37f427e36ee4'; // Branch GUID
		}
		// If no warehouseType specified, we get all warehouses

		return axios.post(`https://api.novaposhta.ua/v2.0/json/`, {
			apiKey: token,
			modelName: 'AddressGeneral',
			calledMethod: 'getWarehouses',
			methodProperties,
		});
	},
};
export const clientsAPI = {
	getMyTeam(props?: RequestTeamType) {
		return instance.post(`user/team-list`, props ? props : {});
	},
	getMyTeamHeader(month: string) {
		return instance.post(`user-stat/team-header`, {month});
	},
	getMyTeamClientOrder(data: {month: string; client_id: number}) {
		return instance.post(`user/team-client-order`, data);
	},
	getUserClientStat(data: {month: string; client_id: number}) {
		return instance.post(`user/team-client-stat`, data);
	},
	getClientInfo(client_id: number) {
		const month = monthNow();
		return instance.post(`user/team-client-card`, {client_id, month});
	},
	sendSms(generateCodeData: GenerateCodeData) {
		return instance.post(`clients/regsponsor-generate-code`, generateCodeData);
	},
	sendBonusSms(client_id: number) {
		return instance.post(`user-msg/bonus`, {client_id});
	},
	approveCodeSms(approveCodeData: ApproveSmsCode) {
		return instance.post(`clients/regsponsor-confirm-code`, approveCodeData);
	},
	approveBonusCodeSms(approveCodeData: ApproveBonusSmsCode) {
		return instance.post(`user-msg/confirm-code`, approveCodeData);
	},
	getClientsTree(month: string) {
		return instance.post(`clients/tree`, {month});
	},
	checkPassword(password: string) {
		return instance.post(`user/check-password`, {password});
	},
	getClientsPresent(client_id: number) {
		return instance.post(`clients/present`, {client_id});
	},
	getActivityTree(month: string) {
		return instance.post(`user-stat/activity-tree`, {month});
	},
	getQlfcLevel(month: string) {
		return instance.post(`user-stat/qlfc-level`, {month});
	},
	searchClientByContract(searchClientData: {contract: string; month: string}) {
		return instance.post(`clients/find-activity`, searchClientData);
	},
	regRequest(registerData: RegisterClientData) {
		return instance.post(`clients/regsponsor-create`, registerData);
	},
	getProfitMonth(month: string) {
		return instance.post(`user-profit/month`, {month});
	},
	getListAllLevels(month: string) {
		return instance.post(`user-profit/list-levels-all`, {month});
	},
	getClientsRegList(month: string) {
		return instance.post(`clients/reg-list`, {month});
	},
	getClientsRegMove(moveData: MoveDataType) {
		return instance.post(`clients/reg-move`, moveData);
	},
};
export const educationAPI = {
	getLessonsList(module_id: number) {
		return instance.post(`user/study-lessons`, {module_id});
	},
	getModuleInfo(module_id: number) {
		return instance.post(`user/study-moduleinfo`, {module_id});
	},
	getSubModuleList(module_id: number) {
		return instance.post(`user/study-submodules`, {module_id});
	},
	getOneLesson(lesson_id: number) {
		return instance.post(`user/study-lesson`, {lesson_id});
	},
	getQuestions(lesson_id: number) {
		return instance.post(`user/study-questions`, {lesson_id});
	},
	getStudyComplete(questions: any, lesson_id: number) {
		return instance.post(`user/study-complete`, {
			questions: questions.data,
			lesson_id,
		});
	},
	getSendFeedback(feedback: string) {
		return instance.post(`user/study-feedback`, {feedback});
	},
};
export const newsAPI = {
	getNewsList(data: RequestDataTypes) {
		return instance.post(`msg/list`, data);
	},
	getTagsList() {
		return instance.post(`msg/tags-list`, {});
	},
	getCategoryList() {
		return instance.post(`msg/category-list`, {});
	},
	getFixedList() {
		return instance.post(`msg/fixed`, {});
	},
	getNewsView(id: number) {
		return instance.post(`msg/text`, {news_id: id});
	},
	getBannerImages(type: string) {
		return instance.post(`msg/banner`, {type: type});
	},
};

export const dynamicAPI = {
	getStatDayVolumeCommand(month: string) {
		return instance.post(`user/statday-volume-command`, {month});
	},
	getAchieveRecommend() {
		return instance.post(`user/achieve-recommend`, {});
	},
	getHistoryQlfc() {
		return instance.post(`user/history-qlfc`, {});
	},
	getHistoryMarketplan() {
		return instance.post(`user/history-marketplan`, {});
	},
	getStatMonthVolumeCommand(month: string) {
		return instance.post(`user-stat/month-volume-command`, {month});
	},
	getMonthNewbie(month: string) {
		return instance.post(`user-stat/month-newbie`, {month});
	},
	getStatLiders(data: {month: string; type_sort: string}) {
		return instance.post(`user-stat/liders`, {...data});
	},
};
export const myAccountsAPI = {
	withdrawalCreate(data: CreateDataWithdrawal) {
		return instance.post(`user-billing/withdrawal-create`, data);
	},
	withdrawal() {
		return instance.post(`user-billing/withdrawal`, {});
	},
	transferCreate(data: CreateDataTransfer) {
		return instance.post(`user-billing/transfer-create`, data);
	},
	getConversionCreate(data: ConversionCreateType) {
		return instance.post(`user-billing/conversion-create`, data);
	},
	getConversion() {
		return instance.post(`user-billing/conversion`, {});
	},
	getSumBonus(month: string) {
		return instance.post(`user/sum-bonus`, {month});
	},
	getBillingPointSmp(month: {month: string}) {
		return instance.post(`user-billing/pointsmp`, month);
	},
	getBillingCashback(data: RequestPremiaType) {
		return instance.post(`user-billing/cashback`, data);
	},
	getBillingOptima(data: RequestPremiaType) {
		return instance.post(`user-billing/optima`, data);
	},
	getBillingTransactions(data: RequestBillingTransactions) {
		return instance.post(`user-billing/transactions`, data);
	},
	getBillingList(month: string) {
		return instance.post(`user-billing/list`, {month});
	},
	getBillingPremia(data: RequestPremiaType) {
		return instance.post(`user-billing/premia`, data);
	},
	getBillingTransfer() {
		return instance.post(`user-billing/user-transfer`, {});
	},
	billingApprove(transaction_id: number) {
		return instance.post(`user-billing/transaction-approve`, {transaction_id});
	},
	billingReject(transaction_id: number) {
		return instance.post(`user-billing/transaction-reject`, {transaction_id});
	},
	billingConfirm(transaction_id: number) {
		return instance.post(`user-billing/transaction-confirm`, {transaction_id});
	},
	billingReceive(transaction_id: number) {
		return instance.post(`user-billing/transaction-receive`, {transaction_id});
	},
};
export const storeOrderAPI = {
	getOrderList(props?: RequestOrdersListType) {
		return instance.post(`store-order/list`, props ? props : {});
	},
	getOrderHistory(props?: RequestTeamType) {
		return instance.post(`store-order/history`, props ? props : {});
	},
	getOrderInfo(order_id: number) {
		return instance.post(`store-order/info`, {order_id});
	},
	getDeleteOrder(order_id: number) {
		return instance.post(`store-order/delete`, {order_id});
	},
	getApproveOrder(props: ApproveOrderRequestType) {
		return instance.post(`store-order/receive`, props);
	},
	getReceiveList(order_id: number) {
		return instance.post(`store-order/receive-list`, {order_id});
	},
	getEditOrder(order_id: number) {
		return instance.post(`store-order/edit`, {order_id});
	},
	getPrintOrder(order_id: number) {
		return instance.post(`store-order/print`, {order_id});
	},

	getStoreList(type_order: string) {
		return instance.post(`store-order/store-list`, {type_order: type_order});
	},
	getStoreProductList() {
		return instance.post(`store-product/list`, {});
	},
	getCategoriesList(type: string) {
		return instance.post(`products/category-list`, {
			type: type ? type : 'client',
		});
	},
	getProductsList(props: ProductsListRequestType) {
		return instance.post(`products/list-order`, props);
	},
	getCreateInvoice(props: CreateInvoiceType) {
		return instance.post(`store-order/create`, props);
	},
	getStoreOrderInfo(order_id: number) {
		return instance.post(`store-logistic/info`, {order_id});
	},
};

export const storeCashierAPI = {
	getPRROStatus() {
		return instance.post(`store-prro/status`, {});
	},
	getAuthCasher(data: AuthFormValues) {
		return instance.post(`store-prro/auth`, data);
	},
	getExitCasher(data: CashierActionType) {
		return instance.post(`store-prro/exit`, data);
	},
	getOpenCasherShift(data: CashierActionType) {
		return instance.post(`store-prro/open-shift`, data);
	},
	getCloseCasherShift(data: CashierShiftExitType) {
		return instance.post(`store-prro/close-shift`, data);
	},
	getCashDeposit(data: CashActionType) {
		return instance.post(`store-prro/cash-deposit`, data);
	},
	getCashWithdrawal(data: CashActionType) {
		return instance.post(`store-prro/cash-withdrawal`, data);
	},
	getXReport(shiftId: string) {
		return instance.post(`store-prro/xreport`, {shift_id: shiftId});
	},
	getZReport(id: string) {
		return instance.post(`store-prro/zreport`, {report_id: id});
	},
	getZReportList() {
		return instance.post(`store-prro/zreport-list`, {});
	},
	getCreateReceipt(data: RequestCreateReceiptType) {
		return instance.post(`store-prro/create`, data);
	},
	getCreateReturnReceipt(data: RequestCreateReceiptReturnType) {
		return instance.post(`store-prro/create-return`, data);
	},
	getPrintReceipt(data: RequestPrintReceiptType) {
		return instance.post(`store-prro/print`, data);
	},
	getBillingList(data: RequestBillingListType) {
		return instance.post(`store-billing/list`, data);
	},
	getAccountsList() {
		return instance.post(`store-billing/account-list`, {});
	},
	getCreateCashOrder(data: RequestCreateCashierOrderType) {
		return instance.post(`store-billing/create`, {...data, type: 'income'}); // income - нужно будет потом убрать
	},
	getEditCashOrder(data: RequestEditCashierOrderType) {
		return instance.post(`store-billing/edit`, {...data, type: 'income'}); // income - нужно будет потом убрать
	},
	getDeleteCashOrder(id: number) {
		return instance.post(`store-billing/delete`, {order_id: id});
	},
	getPaymentList(data: RequestPaymentListType) {
		return instance.post(`store-payment/list`, data);
	},
	getDeletePayment(payment_id: number) {
		return instance.post(`store-payment/delete`, {payment_id});
	},
	getCreatePayment(data: RequestPaymentCreateType) {
		return instance.post(`store-payment/create`, data);
	},
	getVerifyPayment(client_id: string) {
		return instance.post(`store-payment/verify`, {client_id});
	},
	getBonusCheckList(month: string) {
		return instance.post(`store-bonusmp/list`, {month});
	},
	bonusCheckCreate(bonus_id: number) {
		return instance.post(`store-bonusmp/create`, {bonus_id});
	},
	bonusCheckCreateMany(bonus_ids: number[]) {
		return instance.post(`store-bonusmp/create-many`, {bonuses: bonus_ids});
	},
};
export const storeActivitiesAPI = {
	getCreateActivities(props: CreateActivitiesRequestType) {
		return instance.post(`stores-activities/create`, {...props});
	},
	getPaperworkList(props: RequestPaperworkListType) {
		return instance.post(`stores-activities/list`, props ? props : {});
	},
	getPaperworkHistory(props?: RequestPaperworkHistoryType) {
		return instance.post(`stores-activities/history`, props ? props : {});
	},
	deleteActivities(order_id: number) {
		return instance.post(`stores-activities/delete`, {order_id});
	},
	editActivities(order_id: number) {
		return instance.post(`stores-activities/edit`, {order_id});
	},
	printActivities(order_id: number) {
		return instance.post(`stores-activities/print`, {order_id});
	},
};
export const storeReportAPI = {
	getBalanceProducts() {
		return instance.post(`store-report/balance-products`, {});
	},
	getBalanceApprove(data: RequestApproveProductsType) {
		return instance.post(`store-report/balance-approve`, data);
	},
	/*getMovementProducts(props: RequestMovementType) {
		return instance.post(`store-report/movement-products`, props);
	},*/
	getFinBalancePointProducts(month: string) {
		return instance.post(`store-report/finbalance-point-products`, {month});
	},
	getMovementProducts(props: RequestMovementType) {
		return instance.post(`store-report/products`, props);
	},
	getGoodsMovement(props: RequestMovementType) {
		return instance.post(`store-report/movement-product`, props);
	},
	getFinPoints(month: string) {
		return instance.post(`store-report/fin-points`, {month});
	},
	getFinNoPoints(month: string) {
		return instance.post(`store-report/fin-nonpoints`, {month});
	},
	getFinSpecnonpoints(month: string) {
		return instance.post(`store-report/fin-specnonpoints`, {month});
	},
	getFinOthers(month: string) {
		return instance.post(`store-report/fin-others`, {month});
	},
	getFinVolonter(month: string) {
		return instance.post(`store-report/fin-volonter`, {month});
	},
	getFinBalanceProducts(data: RequestBalanceProdType) {
		return instance.post(`store-report/finbalance-products`, data);
	},
	getFinStat(data: RequestStatProdType) {
		return instance.post(`store-report/fin-stat`, data);
	},
	loadFinStat({data, type}: LoadFinStatProps) {
		return instance.post(`store-report/${type}-load`, data);
	},
};
export const storeLogisticAPI = {
	getStoreList(props: LogisticListRequestType) {
		return instance.post(`store-logistic/list`, {...props});
	},
	getDeleteOrder(props: DeleteLogisticOrder) {
		return instance.post(`store-logistic/rejected`, {...props});
	},
	getAcceptProcessingOrder(orderId: number) {
		return instance.post(`store-logistic/working`, {order_id: orderId});
	},
	getApprovePaidOrder(orderId: number) {
		return instance.post(`store-logistic/paid`, {order_id: orderId});
	},
	getShipOrder(orderId: number) {
		return instance.post(`store-logistic/shipped`, {order_id: orderId});
	},
};
